import { useState } from 'react'
import { MenuItem } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Box } from '@mui/system'
import ConfirmationModalContainer from '../../../components/Modals/ConfirmationModalContainer.jsx'
import FinishModalContainer from '../../../components/Modals/FinishModalContainer.jsx'
import {
  retrieveCustomerAdminUsers,
  customerAdminUserChangeStatus,
} from '../../../redux/features/users/customerAdmin/customerAdminThunk'
import ChangePasswordModal from '../../../components/Modals/ChangePasswordModal.jsx'
import UseTranslation from '../../../hooks/UseTranslation.jsx'
import { userActiveStatesList, userDeactivateStatesList } from '../../../utils/modalDataContainer'
import SideButtonContainerWithModal from '../../../components/Cards/helpers/SideButtonContainerWithModal'
import { ReactComponent as ResetPasswordIcon } from '../../../images/resetPassword.svg'
import { ReactComponent as ActivateDeactivateUserIcon } from '../../../images/activateDeactivateUser.svg'
import { ReactComponent as EditUserIcon } from '../../../images/editUser.svg'
import CookiesStorageService from '../../../services/CookiesStorageService'

const CustomerAdminUserActionBtn = ({ user, customStyle }) => {
  const baseUri = process.env.REACT_APP_ROOT_ROUTE || ''
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = UseTranslation()

  const [selectedUserStates, setSelectedUserStates] = useState(null)
  const [selectedUserId, setSelectedUserId] = useState(null)
  const [deactivateModalState, setDeactivateModalState] = useState(false)
  const [finishModalState, setFinishModalState] = useState(false)

  const [changePasswordModalState, setChangePasswordModalState] = useState(false)
  const isSamlUser = CookiesStorageService.getIsSamlUser() || false
  const userProfileHandler = () => {
    history.push(`${baseUri}/edit-user/${user?.id}`)
  }

  const handelOpenModals = ({ id, active }) => {
    setSelectedUserStates(!active)
    setSelectedUserId(id)
    setDeactivateModalState(true)
  }

  const handelCloseModals = () => {
    dispatch(retrieveCustomerAdminUsers({ queries: { pageNumber: 0 } }))
    setDeactivateModalState(false)
    setFinishModalState(false)
  }

  return (
    <Box sx={[styles.root, customStyle && customStyle]}>
      <SideButtonContainerWithModal>
        <MenuItem onClick={userProfileHandler} sx={styles.option}>
        <EditUserIcon/>
          {`${t?.['Edit User Profile']}`}
        </MenuItem>

        {!isSamlUser && (
          <MenuItem onClick={() => setChangePasswordModalState(true)} sx={styles.option}>
          <ResetPasswordIcon/>
            {`${t?.['Reset User’s Password']}`}
          </MenuItem>
        )}
        <MenuItem onClick={() => handelOpenModals(user)} sx={styles.option}>
        <ActivateDeactivateUserIcon/>
          {user?.active ? `${t?.['Deactivate User']}` : `${t?.['Activate User']}`}
        </MenuItem>
      </SideButtonContainerWithModal>

      <ConfirmationModalContainer
        modalState={deactivateModalState}
        setModalState={setDeactivateModalState}
        setFinishModalState={setFinishModalState}
        confirmationData={user?.active ? userDeactivateStatesList : userActiveStatesList}
        confirmHandler={customerAdminUserChangeStatus}
        confirmHandlerQueries={{
          status: selectedUserStates,
          id: selectedUserId,
        }}
      />

      <FinishModalContainer
        modalTitle={user?.active ? userDeactivateStatesList.title : userActiveStatesList.title}
        modalMessage={user?.active ? userDeactivateStatesList.finish : userActiveStatesList.finish}
        modalColor={user?.active ? userDeactivateStatesList.color : userActiveStatesList.color}
        modalState={finishModalState}
        finishHandler={handelCloseModals}
      />

      <ChangePasswordModal
        formModalState={changePasswordModalState}
        setFormModalState={setChangePasswordModalState}
        isResetAdmin={true}
        userId={user?.id}
      />
    </Box>
  )
}

const styles = {
  root: {
    mr: { xs: '-20px', sm: 'initial' },
  },
  dropPopper: {
    border: 'none',
    backgroundColor: { xs: '#fff', md: '#F7F9FB' },
    color: { xs: '#000000', md: 'icon.primary' },
  },
  option: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-end',
    textTransform: 'capitalize',
    cursor: 'pointer',
    padding: { xs: '10px', sm: '10px 15px' },
    margin: '0px',
    '&:hover': {
      backgroundColor: '#f7f9fb',
    },
    gap: '10px',
    fontSize: { xs: '13px', sm: '14px' },
    fontFamily: 'Avenir, Roboto, monospace',
    '& svg:first-of-type': {
      display: { xs: 'flex', sm: 'none' },
      filter: 'brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)',
      width: '20px',
      height: '20px',
    },
  },
}

export default CustomerAdminUserActionBtn
